import type { ElectronAPI } from '../../types/electron';
import {
  readFilesFromDirectoryElectron,
  createFileListFromArray,
} from './fileReadingUtils';
import { detectProjectsFromFiles } from './projectDetection';

export interface ScanProjectsOptions {
  onFileScanned?: (filePath: string) => void;
  readContent?: boolean;
}

export interface ScanProjectsResult {
  files: FileList;
  detectedProjects: ReturnType<typeof detectProjectsFromFiles>;
}

/**
 * Scan for projects in a directory (Electron)
 * @param electronAPI - The Electron API instance
 * @param basePath - The root directory path to scan
 * @param options - Scanning options
 * @returns Promise resolving to files and detected projects
 */
export async function scanProjectsElectron(
  electronAPI: ElectronAPI,
  basePath: string,
  options: ScanProjectsOptions = {}
): Promise<ScanProjectsResult> {
  const { onFileScanned, readContent = false } = options;

  // Read files from directory (metadata-only for fast detection)
  const files = await readFilesFromDirectoryElectron(
    electronAPI,
    basePath,
    '',
    [],
    readContent,
    onFileScanned
  );

  const fileList = createFileListFromArray(files);
  const detectedProjects = detectProjectsFromFiles(fileList, {
    rootFolderName: basePath.split(/[/\\]/).pop() || 'Selected Folder',
  });

  return {
    files: fileList,
    detectedProjects,
  };
}
